import { createPortal } from "react-dom";

export const createPortalOnRootEl = (
  Component: Parameters<typeof createPortal>[0],
  key: Parameters<typeof createPortal>[2] = null
) => {
  const rootEl = document.getElementById("root");
  return rootEl ? createPortal(Component, rootEl, key) : null;
};
